import { Component, Input, Output, EventEmitter } from '@angular/core';
import { isEmpty as _isEmpty } from 'lodash';

import { IDispIsshinTasukeMenuData, IDispIsshinTasukeGroupData } from '../isshin-tasuke-menu.interface';
import { BizMenuContentEx } from '../../biz-menu-page.interface';
import { BusinessMenuGroupId } from '../../biz-menu-page.const';

@Component({
  selector: 'app-isshin-tasuke-menu-view',
  templateUrl: './isshin-tasuke-menu-view.component.html',
  styleUrls: ['./isshin-tasuke-menu-view.component.scss'],
})
export class IsshinTasukeMenuViewComponent {
  /** メニューデータ */
  @Input() menuData: IDispIsshinTasukeMenuData = {};

  /** メニュークリックイベント */
  @Output() clickMenuEvent = new EventEmitter<BizMenuContentEx>();

  /** メモクリックイベント */
  @Output() clickMemoEvent = new EventEmitter<any>();

  /** 業務メニューグループID定義 */
  readonly BusinessMenuGroupId = BusinessMenuGroupId;

  /** アクティブグループインデックス */
  _activeGroupIndex = 0;

  /** アクティブグループID */
  _activeGroupId = 0;

  /** 提供共通メニュー */
  get offerMenuContents(): BizMenuContentEx[] {
    if (this.menuData && this.menuData.offerCommonMenuGroup) {
      return this.menuData.offerCommonMenuGroup.bizMenuContents || [];
    }
    return [];
  }

  /** ユーザー登録共通メニュー */
  get userMenuContents(): BizMenuContentEx[] {
    if (this.menuData && this.menuData.userCommonMenuGroup) {
      return this.menuData.userCommonMenuGroup.bizMenuContents || [];
    }
    return [];
  }

  get productMenuGroups(): IDispIsshinTasukeGroupData[] {
    if (this.menuData && this.menuData.productMenuGroups) {
      return this.menuData.productMenuGroups || [];
    }
    return [];
  }

  /** it-logoの画像パス */
  get itLogoSrc(): string {
    const groupIds = this.productMenuGroups.map((group) => group.businessMenuGroupId);
    const hasMaintenance = groupIds.includes(BusinessMenuGroupId.Maintenance);
    const hasRepair = groupIds.includes(BusinessMenuGroupId.Repair);
    const hasCarsales = groupIds.includes(BusinessMenuGroupId.Carsales);

    if (hasMaintenance && !hasRepair && !hasCarsales) {
      return 'assets/images/logo_isshintasuke_maintenance.png';
    }
    if (!hasMaintenance && hasRepair && !hasCarsales) {
      return 'assets/images/logo_isshintasuke_repair.png';
    }
    if (hasMaintenance && hasRepair && !hasCarsales) {
      return 'assets/images/logo_isshintasuke_maintenance_repair.png';
    }
    if (hasMaintenance && !hasRepair && hasCarsales) {
      return 'assets/images/logo_isshintasuke_maintenance_carsales.png';
    }
    return 'assets/images/logo_isshintasuke_maintenance_repair_carsales.png';
  }

  /** アクティブグループのプロダクトメニュー */
  get activeProductMenuContents(): BizMenuContentEx[] {
    const activeGroup = this.productMenuGroups[this._activeGroupIndex];
    return (activeGroup && activeGroup.bizMenuContents) || [];
  }

  /** アクティブグループのグループID */
  get activeProductGroupId(): number {
    const activeGroup = this.productMenuGroups[this._activeGroupIndex];
    return (activeGroup && activeGroup.businessMenuGroupId) || 0;
  }

  get menuMemo(): string {
    if (this.menuData && this.menuData.isshinTasukeMenuSetting) {
      return this.menuData.isshinTasukeMenuSetting.isshinTasukeMenuMemo || '';
    }
    return '';
  }

  /**
   * プロダクトメニューグループクリックイベントハンドラ
   * @param index インデックス
   * @param businessMenuGroupId 業務メニューグループID
   */
  onClickProductMenuGroup(index: number, businessMenuGroupId: number): void {
    if (this.productMenuGroups.length > index) {
      this._activeGroupIndex = index;
      this._activeGroupId = businessMenuGroupId;
    }
  }

  /**
   * 印刷設定ボタンクリックイベントハンドラ
   */
  onClickPrinterSetting(): void {
    // 印刷設定画面を別タブで表示
    window.open('/maintenance/company/printer', 'blank');
  }

  /**
   * メモクリックイベントハンドラ
   */
  onClickMemoSetting(): void {
    this.clickMemoEvent.emit();
  }

  /**
   * メニュークリックイベントハンドラ
   * @param bizMenuContent メニューコンテンツ
   */
  onClickMenu(bizMenuContent: BizMenuContentEx): void {
    if (bizMenuContent && !_isEmpty(bizMenuContent.urlList)) {
      this.clickMenuEvent.emit(bizMenuContent);
    }
  }

  /**
   * タジマサポートサイトクリックイベントハンドラ
   */
  onClickSupportSite() {
    window.open('https://www.tajima-portal.jp/', 'blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/isshin-tasuke-menu/view/isshin-tasuke-menu-view.component.ts